import React from 'react'
import { Divider, Row, Form, Button, Input, Switch, notification } from 'antd'
import API from '../../services/API'
import Segment from '../../components/Segment'
import { Link } from 'react-router-dom'

const INIT = {
    code: '',
    description: '',
    active: true,
}

const SatCodeCreateContainer = () => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const disabled = !data.code || !data.description

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        API.post('/api/sat_code', data)
            .then(() => {
                setloading(false)
                setData(INIT)

                notification.success({
                    message: 'El codigo sat se ha creado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Crear codigo sat</Divider>
            <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>
                <Form.Item label="codigo" className="required" hasFeedback>
                    <Input
                        placeholder="Codigo"
                        value={data.code}
                        onChange={e => {
                            handleChange('code', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Descripición" className="required" hasFeedback>
                    <Input
                        placeholder="Descripición"
                        value={data.description}
                        onChange={e => {
                            handleChange('description', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/categories">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>



            </Form>
        </Segment>
    )
}

export default SatCodeCreateContainer
